<template>
  <div style="padding: 24px;height: 1198px;overflow-y: auto">
    <img v-if="id" src="../../../assets/images/Ad/upd_template.png" alt="" class="ad_img">
    <img v-else src="../../../assets/images/Ad/new_template.png" alt="" class="ad_img">
    <div style="background-color: #fff;border-radius: 8px;margin: 20px 0">
      <el-form label-position="top" class="custom-label-form">
        <el-form-item class="form_item_box" label="推广项目">
          <div class="container">
            <div class="label-with-input">
              <span> <span class="redsp">*</span>优化目标 </span>
              <el-select v-model="form_data.external_action" placeholder="请选择" style="width: 100%" @change="validateField('external_action')">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :class="{ 'is-error': formErrors.external_action }"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <div v-if="formErrors.external_action" class="form-error-text">{{ formErrors.external_action }}</div>
              <div v-if="form_data.external_action === 'AD_CONVERT_TYPE_ACTIVE'">
                深度优化目标
                <el-select v-model="form_data.deep_external_action" placeholder="请选择" clearable style="width: 100%" @change="form_data.bid_type = 'CUSTOM'">
                  <el-option
                    label="广告变现ROI"
                    value="AD_CONVERT_TYPE_LT_ROI"
                  />
                </el-select>
              </div>
            </div>
            <div class="label-with-input">
              投放模式
              <el-radio-group v-model="form_data.delivery_mode" @change="handleDeliveryModeChange">
                <el-radio-button label="PROCEDURAL">自动投放</el-radio-button>
                <el-radio-button label="MANUAL">手动投放</el-radio-button>
              </el-radio-group>
            </div>
            <div v-if="form_data.delivery_mode === 'PROCEDURAL'" class="label-with-input">
              AIGC动态创意
              <el-radio-group v-model="form_data.aigc_dynamic_creative_switch">
                <el-radio-button label="ON">启用</el-radio-button>
                <el-radio-button label="OFF">不启用</el-radio-button>
              </el-radio-group>
            </div>
            <div v-else class="label-with-input">
              投放位置
              <el-radio-group v-model="form_data.inventory_catalog_type">
                <el-radio-button label="通投智选" />
                <el-radio-button label="首选媒体" />
              </el-radio-group>
              <div v-show="form_data.inventory_catalog_type=== '首选媒体'" style="border: 1px solid #DCDFE6;border-radius: 8px">
                <div style="background-color: #F5F7FA; padding: 4px 12px">
                  <el-checkbox
                    v-model="checkAll"
                    :indeterminate="isIndeterminate"
                    @change="handleCheckAllChange"
                  >
                    媒体选择
                  </el-checkbox>
                </div>

                <!-- 媒体多选 -->
                <div style="padding: 12px">
                  <el-checkbox-group
                    v-model="form_data.inventory_catalog"
                    class="checkbox-grid"
                    @change="handleCheckedChange"
                  >
                    <el-checkbox
                      v-for="item in icon_tabs"
                      :key="item.value"
                      :label="item.value"
                      class="checkbox-item"
                    >
                      <!-- 图标 + 文本 -->
                      <img
                        :src="item.img"
                        alt="icon"
                        style="width: 18px; height: 18px; margin-right: 8px;"
                      >
                      <span>{{ item.name }}</span>
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <div class="line" />
        <el-form-item class="form_item_box" label="排期与预算出价">
          <div class="container">
            <div class="label-with-input">
              投放时间
              <el-radio-group v-model="form_data.schedule_type">
                <el-radio-button label="SCHEDULE_FROM_NOW">从今天起长期投放</el-radio-button>
                <el-radio-button label="SCHEDULE_START_END">设置开始和结束时间</el-radio-button>
              </el-radio-group>
              <div v-if="form_data.schedule_type === 'SCHEDULE_START_END'">
                <el-date-picker
                  v-model="scheduleRange"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                />
              </div>
            </div>
            <div class="label-with-input">
              竞价策略
              <el-radio-group v-model="form_data.bid_type">
                <el-radio-button label="CUSTOM">稳定成本</el-radio-button>
                <el-radio-button v-if="form_data.delivery_mode === 'MANUAL'" :disabled="form_data.deep_external_action==='AD_CONVERT_TYPE_LT_ROI'" label="UPPER_CONTROL">最优成本</el-radio-button>
                <el-radio-button :disabled="form_data.deep_external_action==='AD_CONVERT_TYPE_LT_ROI'" label="NO_BID">最大转化</el-radio-button>
              </el-radio-group>
            </div>
            <div v-if="form_data.bid_type=== 'CUSTOM'" class="label-with-input">
              目标转化出价/预期成本
              <el-input v-model="form_data.cpa_bid" :class="{ 'is-error': formErrors.cpa_bid}" placeholder="请输入" style="width: 200px" @blur="validateField('cpa_bid')" />
              <div v-if="formErrors.cpa_bid" class="form-error-text">{{ formErrors.cpa_bid }}</div>
            </div>
            <div class="label-with-input">
              <span> <span v-if="form_data.delivery_mode === 'MANUAL' && form_data.deep_external_action !== 'AD_CONVERT_TYPE_LT_ROI'" class="redsp">*</span> 定向扩展</span>
              <el-radio-group v-model="form_data.audience_extend">
                <el-radio-button label="ON">开</el-radio-button>
                <el-radio-button label="OFF">关</el-radio-button>
              </el-radio-group>
            </div>
            <div :class="['label-with-input', { 'is-error': formErrors.budget }]">
              <span><span class="redsp">*</span>预算</span>
              <el-radio-group v-model="form_data.budget_mode">
                <el-radio-button label="BUDGET_MODE_INFINITE" :disabled="form_data.delivery_mode==='PROCEDURAL'">不限</el-radio-button>
                <el-radio-button label="BUDGET_MODE_DAY">日预算</el-radio-button>
              </el-radio-group>
              <div v-if="form_data.budget_mode!== 'BUDGET_MODE_INFINITE'">
                <el-input v-model="form_data.budget" :class="{ 'is-error': formErrors.budget }" placeholder="请输入" style="width: 200px" @blur="validateField('budget')"> <span slot="suffix">元</span></el-input>
                <div v-if="formErrors.budget" class="form-error-text">{{ formErrors.budget }}</div>
              </div>
            </div>
            <div class="label-with-input">
              付费方式
              <el-radio-group v-model="form_data.pricing">
                <el-radio-button label="PRICING_CPM">按展示付费（ocpm）</el-radio-button>
              </el-radio-group>
            </div>
            <div v-if="form_data.deep_external_action === 'AD_CONVERT_TYPE_LT_ROI'" class="label-with-input">
              <span><span class="redsp">*</span>ROI系数</span>
              <el-input v-model="form_data.roi_goal" :class="{ 'is-error': formErrors.roi_goal }" placeholder="请输入" style="width: 200px" @blur="validateField('roi_goal')" />
              <div v-if="formErrors.roi_goal" class="form-error-text">{{ formErrors.roi_goal }}</div>
            </div>
            <div class="label-with-input">
              <span>出价系数</span>
              <el-input v-model="form_data.search_bid_ratio" :class="{ 'is-error': formErrors.search_bid_ratio }" placeholder="请输入" style="width: 200px" @blur="validateField('search_bid_ratio')"> <span slot="suffix">元</span></el-input>
              <div v-if="formErrors.search_bid_ratio" class="form-error-text">{{ formErrors.search_bid_ratio }}</div>
            </div>
            <div :class="['label-with-input', { 'seletime': timeSwitch === 'OFF' }]">
              投放时段
              <el-radio-group v-model="timeSwitch" @change="timeHandle">
                <el-radio-button label="ON">不限</el-radio-button>
                <el-radio-button label="OFF">选择时间段</el-radio-button>
              </el-radio-group>
              <timeSelection v-if="timeSwitch === 'OFF'" @update-selected="updDataTime" />
            </div>
          </div>
        </el-form-item>
        <div class="line" />
        <el-form-item class="form_item_box" label="第三方检测链接">
          <div class="container">
            <div class="label-with-input">
              展示
              <el-input v-model="form_data.track_url" placeholder="请输入链接地址" />
            </div>
            <div class="label-with-input">
              有效触点
              <el-input v-model="form_data.action_track_url" placeholder="请输入链接地址" />
            </div>
            <div class="label-with-input">
              视频播放
              <el-input v-model="form_data.video_play_first_track_url" placeholder="请输入链接地址" />
            </div>
            <div class="label-with-input">
              视频播完
              <el-input v-model="form_data.video_play_done_track_url" placeholder="请输入链接地址" />
            </div>
            <div class="label-with-input">
              视频有效播放
              <el-input v-model="form_data.video_play_effective_track_url" placeholder="请输入链接地址" />
            </div>
          </div>
        </el-form-item>
        <div class="line" />
        <el-form-item class="form_item_box" label="项目名称">
          <div class="container">
            <div :class="['label-with-input', { 'is-error': formErrors.name }]">
              <span><span class="redsp">*</span>项目名称</span>
              <el-input v-model="form_data.name" placeholder="请输入项目名称" :class="{ 'is-error': formErrors.name }" @blur="validateField('name')" />
              <div v-if="formErrors.name" class="form-error-text">{{ formErrors.name }}</div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <img v-if="id" src="../../../assets/images/Ad/upd_ad.png" alt="" class="ad_img">
    <img v-else src="../../../assets/images/Ad/new_ad.png" alt="" class="ad_img">
    <div style="background-color: #fff;border-radius: 8px;margin: 20px 0">
      <el-form label-position="top" class="custom-label-form">
        <el-form-item class="form_item_box" label="广告素材">
          <div class="container">
            <div class="label-with-input">
              <span> <span class="redsp">*</span>文案标题</span>
              <lsc-input @input="val => updInput('title', val)" />
            </div>
            <div v-if="false" class="label-with-input">
              优化目标
              <el-select v-model="form_data.value" placeholder="请选择" style="width: 100%">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
        </el-form-item>
        <div class="line" />
        <el-form-item class="form_item_box" label="产品信息">
          <div class="container">
            <div class="label-with-input">
              <span> <span class="redsp">*</span>产品名称</span>
              <el-input v-model="form_data.titles" :class="{ 'is-error': formErrors.titles }" placeholder="请输入" @blur="validateField('titles')" />
              <div v-if="formErrors.titles" class="form-error-text">{{ formErrors.titles }}</div>
            </div>
            <div class="label-with-input">
              <span> <span class="redsp">*</span>产品主图</span>
              <!-- 如果有图片则显示图片预览框 -->
              <div v-if="form_data.image_ids" class="custom-upload-box image-preview">
<!--                <img :src="form_data.image_ids" alt="图片预览" class="preview-img">-->
                <el-image
                  class="preview-img"
                  :src="form_data.image_ids"
                  :preview-src-list="[form_data.image_ids]"
                >
                </el-image>
                <span class="delete-btn" @click.stop="removeImage">×</span>
              </div>
              <div
                v-else
                class="custom-upload-box"
                style="border: 1px solid red"
                @click="handleCustomUpload"
              >
                <i class="el-icon-plus" />
                <input
                  ref="fileInput"
                  type="file"
                  accept="image/*"
                  style="display: none"
                  @change="handleFileChange"
                >
              </div>
              <div v-if="formErrors.image_ids" class="form-error-text"> {{ formErrors.image_ids }}</div>
            </div>
            <div class="label-with-input">
              <span> <span class="redsp">*</span>定向包</span>
              <el-select
                v-model="form_data.audience_package_id"
                placeholder="请输入定向包名称"
                filterable
                remote
                reserve-keyword
                :remote-method="fetchUserList"
                :loading="loading"
                :clearable="true"
                @focus="handleUserSearch"
              >
                <el-option
                  v-for="item in package_data"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>
            <div class="label-with-input" style="visibility: hidden" />
          </div>
          <div class="container">
            <div class="label-with-input">
              <span> <span class="redsp">*</span>产品买点</span>
              <lsc-input @input="val => updInput('selling_points', val)" />
            </div>
          </div>
        </el-form-item>
        <div class="line" />
        <el-form-item class="form_item_box" label="广告设置">
          <div class="container">
            <div class="label-with-input">
              <span> <span class="redsp">*</span>行动号召</span>
              <lsc-input @input="val => updInput('call_to_action_buttons', val)" />
            </div>
            <div class="label-with-input">
              <span> <span class="redsp">*</span>广告来源</span>
              <el-input v-model="form_data.source" :class="{ 'is-error': formErrors.source}" placeholder="请输入来源" @blur="validateField('source')" />
              <div v-if="formErrors.source" class="form-error-text"> {{ formErrors.source }}</div>
            </div>
            <div class="label-with-input">
              <span> <span class="redsp">*</span>广告评论</span>
              <el-radio-group v-model="form_data.is_comment_disable">
                <el-radio-button label="ON">启用</el-radio-button>
                <el-radio-button label="OFF">不启用</el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </el-form-item>
        <div class="line" />
        <el-form-item class="form_item_box" label="广告名称">
          <div class="container">
            <div class="label-with-input">
              <span> <span class="redsp">*</span>广告名称</span>
              <el-input v-model="form_data.promotion_name" :class="{ 'is-error': formErrors.promotion_name }" placeholder="请输入广告名称" @blur="validateField('promotion_name')" />
              <div v-if="formErrors.promotion_name" class="form-error-text"> {{ formErrors.promotion_name }}</div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div style="background-color: #FFFFFF;border-radius: 8px;height: 80px;" class="button-box-itemfoot">
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button type="info">取消</el-button>
    </div>
    <el-dialog
      :visible.sync="visible"
      title="保存为模版"
      width="500px"
      style="border-radius: 16px"
    >
      <el-form label-width="120">
        <el-form-item label="模版名称">
          <el-input v-model="form_data.template_name" style=""></el-input>
        </el-form-item>
        <div class="button-box-itemfoot">
          <el-button type="info" @click="visible= false">取消</el-button>
          <el-button type="primary" @click="updAdTemp">保存并使用</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import timeSelection from './components/timeSelection.vue'
import lscInput from './components/lsc-Input.vue'
import { getQcConfig } from '@/api/baiduAD'
import { uploadFileToCos } from '@/utils/ObjectStorage'
import { packageList, setupTemplateCreate } from '@/api/customer'

export default {
  components: { timeSelection, lscInput },
  data() {
    return {
      staticRules: {
        budget: [
          (val) => !!val || '请输入预算',
          (val) => !isNaN(val) || '必须是数字',
          (val) => Number(val) >= 300 || '预算不能低于300元',
          (val) => Number(val) <= 9999999.99 || '预算不能高于9999999.99元'
        ],
        external_action: [
          (val) => !!val || '请选择一个选项'
        ],
        roi_goal: [
          val => {
            if (val === '' || val === null || val === undefined) return 'roi不能为空'
            const num = Number(val)
            if (isNaN(num)) return '必须是数字'
            if (!(num > 0 && num <= 5)) return '必须在 (0, 5] 范围内'
            // 判断小数点后最多4位
            const decimalPart = val.toString().split('.')[1]
            if (decimalPart && decimalPart.length > 4) return '最多保留4位小数'
            return true
          }
        ],
        name: [(val) => !!val || '请输入项目名称'],
        titles: [(val) => !!val || '请输入产品名称'],
        image_ids: [(val) => !!val || '请选择图片'],
        source: [(val) => !!val || '请输入广告来源'],
        promotion_name: [(val) => !!val || '请输入广告名称']
      },
      formErrors: {},
      form_data: {
        delivery_mode: 'PROCEDURAL',
        deep_external_action: null,
        aigc_dynamic_creative_switch: 'ON',
        external_action: null,
        schedule_type: 'SCHEDULE_FROM_NOW',
        bid_type: 'CUSTOM',
        pricing: 'PRICING_CPM',
        bzyswhye: null,
        inventory_catalog_type: '通投智选',
        start_time: null,
        end_time: null,
        budget_mode: 'BUDGET_MODE_DAY',
        budget: null,
        inventory_catalog: [],
        cpa_bid: null,
        search_bid_ratio: null,
        audience_extend: 'ON',
        track_url: '',
        action_track_url: '',
        video_play_first_track_url: '',
        video_play_done_track_url: '',
        video_play_effective_track_url: '',
        name: '',
        title: '',
        titles: '',
        image_ids: '',
        selling_points: '',
        call_to_action_buttons: '',
        source: '',
        is_comment_disable: 'ON',
        promotion_name: '',
        template_name: '',
        audience_package_id: null
      },
      options: [
        { label: '激活', value: 'AD_CONVERT_TYPE_ACTIVE' },
        { label: '关键行为', value: 'AD_CONVERT_TYPE_GAME_ADDICTION' }
      ],
      checkAll: false,
      isIndeterminate: false,
      icon_tabs: [
        { img: require('@/assets/images/Ad/TouTiao.png'), value: 'INVENTORY_FEED', name: '今日头条' },
        { img: require('@/assets/images/Ad/XiGua.png'), value: 'INVENTORY_VIDEO_FEED', name: '西瓜信息流' },
        { img: require('@/assets/images/Ad/TikTok.png'), value: 'INVENTORY_AWEME_FEED', name: '抖音信息流' },
        { img: require('@/assets/images/Ad/FanQie.png'), value: 'INVENTORY_TOMATO_NOVEL', name: '番茄小说' },
        { img: require('@/assets/images/Ad/IrUjJw.png'), value: 'INVENTORY_UNION_SLOT', name: '穿山甲' }
      ],
      visible: false,
      config: {},
      package_visible: false,
      package_query: {
        page: 1,
        page_size: 10
      },
      package_data: [],
      id: null,
      loading: false,
      timeSwitch: 'ON'
    }
  },
  computed: {
    finalRules() {
      const rules = { ...this.staticRules }

      if (this.form_data.budget_mode !== 'BUDGET_MODE_INFINITE') {
        rules.budget = this.staticRules.budget
      } else {
        rules.budget = [] // 不需要校验
      }
      if (this.form_data.deep_external_action === 'AD_CONVERT_TYPE_LT_ROI') {
        rules.roi_goal = this.staticRules.roi_goal
      } else {
        rules.roi_goal = []
      }
      if (this.form_data.bid_type === 'CUSTOM' && this.form_data.deep_external_action !== 'AD_CONVERT_TYPE_LT_ROI') {
        rules.cpa_bid = [
          (val) => !!val || '请输入出价'
        ]
      }
      if (this.form_data.delivery_mode === 'MANUAL' && this.form_data.deep_external_action !== 'AD_CONVERT_TYPE_LT_ROI' && this.form_data.bid_type !== 'NO_BID') {
        rules.search_bid_ratio = [
          (val) => !!val || '请输入出价系数'
        ]
      }
      return rules
    },
    scheduleRange: {
      get() {
        return this.form_data.start_time && this.form_data.end_time ? [this.form_data.start_time, this.form_data.end_time] : []
      },
      set(val) {
        if (Array.isArray(val)) {
          this.form_data.start_time = val[0] || ''
          this.form_data.end_time = val[1] || ''
        }
      }
    }
  },
  created() {
    this.getconfig()
  },
  methods: {
    handleCustomUpload() {
      this.$refs.fileInput.click()
    },
    validateField(field) {
      console.log(field)
      const value = this.form_data[field]
      const fieldRules = this.finalRules[field]
      if (fieldRules && Array.isArray(fieldRules)) {
        for (const rule of fieldRules) {
          const result = rule(value)
          if (result !== true) {
            this.$set(this.formErrors, field, result)
            return
          }
        }
      }
      this.$delete(this.formErrors, field)
    },

    validateAll() {
      Object.keys(this.finalRules).forEach(field => {
        this.validateField(field)
      })
      return Object.keys(this.formErrors).length === 0
    },
    onSubmit() {
      console.log(this.form_data)
      if (!this.validateAll()) {
        console.log(this.formErrors)
        return this.$message.error('请填写完善信息')
      }
      this.visible = true
    },
    handleCheckAllChange(val) {
      if (val) {
        this.form_data.inventory_catalog = this.icon_tabs.map(item => item.value)
      } else {
        this.form_data.inventory_catalog = []
      }
      this.isIndeterminate = false
    },
    handleCheckedChange(val) {
      const checkedCount = val.length
      const total = this.icon_tabs.length
      this.checkAll = checkedCount === total
      this.isIndeterminate = checkedCount > 0 && checkedCount < total
    },
    updDataTime(val) {
      console.log(val.flat().map(val => (val ? '1' : '0')).join(''))
      this.form_data.schedule_time = val.flat().map(val => (val ? '1' : '0')).join('')
    },
    handleDeliveryModeChange(val) {
      if (val === 'PROCEDURAL') {
        this.form_data.budget_mode = 'BUDGET_MODE_DAY'
      }
    },
    updInput(field, val) {
      console.log(val)
      this.form_data[field] = val
    },
    updAdTemp() {
      if (this.form_data.template_name) {
        setupTemplateCreate(this.form_data).then((res) => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('新增成功')
            this.visible = false
            this.$router.push('/massiveAdvertisingAD/AdvertisingTemplate/index')
          }
        })
      }
      console.log(this.form_data)
    },
    async handleFileChange(e) {
      const file = e.target.files[0]
      if (!file) return

      try {
        const url = await this.uploadToCosAndSave(file) // 等待 Promise 返回结果
        if (url) {
          this.form_data.image_ids = url
        }
      } catch (err) {
        this.$message.error(`上传失败: ${err}`)
      }
    },
    removeImage() {
      this.form_data.image_ids = null
      // 清除字段，例如 this.form_data.xxx = null;
    },
    async getconfig() {
      const res = await getQcConfig()
      console.log(res)
      this.config = res.data.qcconfig
    },
    uploadToCosAndSave(file) {
      const folderName = 'chameleon' // 你自己想放的文件夹

      return uploadFileToCos(file, percent => {
        console.log(`上传进度 ${percent}%`)
      }, folderName, this.config).then(cosKey => {
        // 成功后提示

        // 获取随机文件名部分（Key 里最后一段）
        const cosFileName = cosKey.split('/').pop()

        // 这里拼装你要提交给后台的参数
        const recordParams = {
          file_text: file.name,
          file_name: cosKey,
          cos_file_name: cosFileName
        }
        console.log(recordParams, '这是之后拼装参数到后端')
        console.log(this.config.domain + cosKey, '这是之后')
        return this.config.domain + cosKey
        // 调用接口把记录存到后台
      }).catch(err => {
        this.$message.error(`${file.name} 上传失败！--${err}`)
      })
    },
    list() {
      packageList(this.package_query).then(res => {
        this.package_data = res.data.data.list
      })
      this.loading = false
    },
    fetchUserList(query) {
      console.log(query)
      if (query) {
        this.package_query.name = query
      }
      this.loading = true
      this.list()
    },
    handleUserSearch() {
      this.fetchUserList('')
    },
    timeHandle() {
      this.form_data.schedule_time = '1'.repeat(7 * 48)
    }
  }
}
</script>

<style scoped>
.custom-label-form >>> .el-form-item__label {
  font-size: 16px;
  font-weight: bold; /* 可选 */
}
.line {
  height: 1px;
  width: 100%;
  background-color: #E6EBF2;
}
.form_item_box{
  padding: 20px 24px;
}
.container {
  display: flex;
  flex-wrap: wrap;
  padding-left: 20px;
  gap: 20px 100px; /* 行间距20px，列间距100px */
}

.label-with-input {
  flex: 0 0 calc((100% - 2 * 100px - 20px) / 3);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.seletime {
  display: flex;
  flex-direction: column;
  flex: 0 0 100%;
  width: 2600px;
  gap: 4px;
}
.custom-upload-box {
  width: 50px;
  height: 50px;
  border: 1px dashed #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8c939d;
  font-size: 28px;
  cursor: pointer;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
}
.redsp {
  color: red;
}

.form-error-text {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  margin-top: 4px;
}
.is-error ::v-deep .el-input__inner,
.is-error ::v-deep .el-select .el-input__inner {
  border-color: #f56c6c !important;
  color: #A3AAB3 !important;
  background-color: #FFECE8 !important;
}
.checkbox-grid {
  display: flex;
  flex-wrap: wrap;
  column-gap: 16px; /* 两列间隔 */
  row-gap: 12px;     /* 行间隔 */
}

.checkbox-item {
  width: calc(43% - 10px); /* 两列布局 - 控制每个元素占一半宽度减间距 */
  display: flex;
  align-items: center;
}
.image-preview .preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-preview .delete-btn {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 18px;
  height: 18px;
  background: red;
  color: white;
  font-size: 12px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.button-box-itemfoot{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.ad_img {
  width: 118px;height: 30px;
}
::v-deep .el-form-item {
  margin-bottom: 0; /* 你想设置的新值 */
}
::v-deep .el-input:not(.el-date-editor) .el-input__inner {
  height: 36px;             /* 设置输入框高度 */
  font-size: 14px;          /* 字体大小 */
  border-radius: 6px;       /* 圆角 */
  padding: 0 12px;          /* 内边距 */
  background-color: #F2F3F5;/* 背景色 */
  border: 0 solid #ccc;   /* 边框 */
  color:  #000;              /* 字体颜色 */
  box-shadow: none;         /* 去掉聚焦时阴影 */
}

/* 所有 radio button 的基础样式 */
::v-deep .el-radio-button__inner {
  background-color: #f2f2f2 !important;
  color: #666666 !important;
  border: none !important;
  padding: 10px 20px;
  font-size: 14px;
  transition: all 0.2s;
  box-shadow: none !important;
}

/* 选中状态 */
::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #ffffff !important;
  color: #165DFF !important;
  border: 1px solid  #165DFF !important;
  box-shadow: none !important;
}

/* hover 效果（可选） */
::v-deep .el-radio-button__inner:hover {
  color: #409EFF;
}

/* 去除左右连接边框 */
::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-left: none;
}

/deep/ .el-checkbox__inner {
  width: 18px !important;
  height: 18px !important;
  border-radius: 3px;
}
/deep/ .el-checkbox__inner::after {
  /* 调整位置 */
  top: 2px !important;
  left: 5px !important;
  /* 控制“√”的形状 */
  width: 4px !important;
  height: 8px !important;
  border-width: 2px !important;
}

.checkbox-grid /deep/ .el-checkbox.is-checked .el-checkbox__label {
  color: inherit !important;
  font-weight: normal !important;
}
/* hover 时添加边框 */
::v-deep .el-input__inner:hover {
  border: 1px solid #165dff !important; /* 自定义颜色 */
}
.is-error ::v-deep .el-input__inner:hover {
  border-color: #d93025 !important; /* 更深一点的红色 */
}
::v-deep .el-input__inner:focus {
  background-color: #ffffff !important;
  border: 1px solid #165dff !important;
}
.is-error ::v-deep .el-input__inner:focus {
  border-color: #d93025 !important; /* 更深一点的红色 */
}
::v-deep .el-dialog {
  border-radius: 16px;
}
::v-deep .el-dialog__body {
  padding: 24px 20px;
}
::v-deep .el-image-viewer__close {
  color: #fff !important;
}

::v-deep .el-image-viewer__close .el-icon {
  color: #fff !important;
  fill: #fff !important;
}

::v-deep .el-image-viewer__close svg {
  fill: #fff !important;
}
</style>
